import React, { forwardRef } from 'react';

import classnames from 'classnames';
import { Typography as MUITypography } from '@material-ui/core';
import type { TypographyProps } from '@material-ui/core/Typography';

import type { KlpStyled } from '../Theme';
import { removeKlpStyles } from '../Theme';
import type { IKlpPalette } from '../Theme/IKlpStyles';
import { KlpPalette } from '../Theme/KlpPalette';
import type { WithTranslation } from '../TranslationOrChildren';
import { TranslationOrChildren } from '../TranslationOrChildren';
import { useKlpStyles } from '../Theme/useKlpStyles';

interface IOwnProps {
    background?: keyof Omit<IKlpPalette, 'background'>;
}

export type IBlockProps = IOwnProps &
    KlpStyled &
    TypographyProps &
    WithTranslation;

export const Block = forwardRef<HTMLDivElement, IBlockProps>(
    (
        {
            children,
            className,
            translation,
            translationOptions,
            background,
            ...restProps
        },
        ref,
    ) => {
        const styles = useKlpStyles(restProps);
        return (
            <MUITypography
                ref={ref}
                variant="body1"
                variantMapping={{ body1: 'div' }}
                className={classnames(styles.klpStyles, className)}
                style={{
                    backgroundColor: background && KlpPalette[background].light,
                }}
                {...removeKlpStyles(restProps)}
            >
                <TranslationOrChildren
                    translation={translation}
                    translationOptions={translationOptions}
                >
                    {children}
                </TranslationOrChildren>
            </MUITypography>
        );
    },
);
Block.displayName = 'Block';
